export default "__VITE_ASSET__CoUCADLW__"